module.exports = __webpack_public_path__ + "img/airas-sub-features-1.a27a216.jpg";